export const resolveImageUrl = (pic) => {
    if (!pic) return null;
    if (typeof pic === 'string' && pic.trim().length > 0) return pic;
    if (typeof pic === 'object') {
        if (pic.onlinePath && typeof pic.onlinePath === 'string') return pic.onlinePath;
        if (pic.url && typeof pic.url === 'string') return pic.url;
        if (pic.path && typeof pic.path === 'string' && pic.path.startsWith('http')) return pic.path;
        if (pic.downloadUrl && typeof pic.downloadUrl === 'string') return pic.downloadUrl;
    }
    return null;
};

export const getProductCoverUrl = (p) => {
    if (!p) return '/logo192.png';

    // 1. coverRef pointing to image in pictures map
    if (p.coverRef && p.pictures && p.pictures[p.coverRef]) {
        const url = resolveImageUrl(p.pictures[p.coverRef]);
        if (url) return url;
    }

    // 2. Picture marked as isCover === true
    if (p.pictures && typeof p.pictures === 'object') {
        const picList = Array.isArray(p.pictures) ? p.pictures : Object.values(p.pictures);
        const coverPic = picList.find(pic => pic && pic.isCover);
        if (coverPic) {
            const url = resolveImageUrl(coverPic);
            if (url) return url;
        }

        // 3. First valid image in pictures map/array
        for (const pic of picList) {
            const url = resolveImageUrl(pic);
            if (url) return url;
        }
    }

    // 4. Direct coverUrl / onlinePath / picture / imageUrl / cover fields
    const directCover = resolveImageUrl(p.coverUrl) 
        || resolveImageUrl(p.onlinePath) 
        || resolveImageUrl(p.picture) 
        || resolveImageUrl(p.imageUrl) 
        || resolveImageUrl(p.cover);
    
    if (directCover) return directCover;

    return '/logo192.png';
};

export const getAllProductImages = (p) => {
    if (!p) return [];
    const imagesMap = {};

    if (p.pictures && typeof p.pictures === 'object') {
        if (Array.isArray(p.pictures)) {
            p.pictures.forEach((pic, idx) => {
                const url = resolveImageUrl(pic);
                if (url) imagesMap[`pic_${idx}`] = { id: `pic_${idx}`, url, isCover: pic?.isCover || false };
            });
        } else {
            Object.entries(p.pictures).forEach(([id, pic]) => {
                const url = resolveImageUrl(pic);
                if (url) imagesMap[id] = { id, url, isCover: pic?.isCover || false };
            });
        }
    }

    const coverUrl = getProductCoverUrl(p);
    if (coverUrl && coverUrl !== '/logo192.png') {
        const exists = Object.values(imagesMap).some(img => img.url === coverUrl);
        if (!exists) {
            const coverId = p.coverRef || 'cover_main';
            imagesMap[coverId] = { id: coverId, url: coverUrl, isCover: true };
        }
    }

    return Object.values(imagesMap);
};
